import {
  UniFiCategoryId,
  UniFiChildCategorySlug,
} from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/physical-security/dome-turret/ai-360.png";
import type { Product } from "../../types";
import { physicalSecurityDomeTurret } from "../product-list-groups/physicalSecurityDomeTurret";
import { deployment } from "../properties/deployment";
import { outdoorReady } from "../properties/outdoorReady";

export const ai360: Product = {
  id: "ai360",
  productTitle: "AI 360",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.CamerasNVRs}/uvc-ai-360`,
  ],
  storePathParts: {
    productSlug: "uvc-ai-360",
    category: UniFiChildCategorySlug.CamerasDomeTurret,
  },
  sku: "UVC-AI-360",
  description: "ai360.description",
  descriptionMaxWidth: 170,
  image: { src: image, width: 200, height: 140 },
  productListGroup: physicalSecurityDomeTurret,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: 'Ø147 x 49 mm\n(Ø5.8 x 1.9")',
      },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "2K" },
    },
    {
      propertyId: "imageSensor",
      value: { type: "string", value: "5MP CMOS" },
    },
    {
      propertyId: "fieldOfView",
      value: {
        type: "translation",
        value: "ai360.fieldOfView",
      },
    },
    {
      propertyId: "nightVision",
      value: { type: "string", value: "9 m (30 ft)" },
    },
    {
      propertyId: "opticalZoom",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "smartDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "aiRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "licensePlateRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "cameraAudio",
      value: {
        type: "translation",
        value: "commons.cameraAudio.twoWayAudio",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: {
        type: "translation",
        value: "ai360.outdoorReady",
      },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "string", value: "IK08" },
    },
    {
      propertyId: deployment.id,
      value: { type: "string", value: "PoE" },
    },
  ],
};
